'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = initCustomNavFlickity;

var _flickityFade = require('flickity-fade');

var _flickityFade2 = _interopRequireDefault(_flickityFade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('flickity-imagesloaded');

/**
 * Init Flickity
 *
 * @param   node      container       - The container element node. Flickity gallery and arrows should be within this container.
 * @param   object    flickityOptions - The specific flickity api options for this initialization.
 *
 * output   Sets up a Flickity slider instance with standard slider customizations done via the api.
 */

function initCustomNavFlickity(container) {
  var flickityOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // Target the flickity slider instance and init.

  var flickityGallery = container.querySelector('.flickity');
  var flickity = new _flickityFade2.default(flickityGallery, flickityOptions);

  /*--------------------
  Classes
  --------------------*/
  if (flickity.slides.length === 1) {
    container.classList.add('no-nav');
  }

  /*--------------------
  Arrow Nav
  --------------------*/

  var flickityArrows = container.querySelectorAll('.flickity__arrow');

  if (flickityArrows.length > 0) {
    [].concat((0, _toConsumableArray3.default)(flickityArrows)).forEach(function (arrow) {
      arrow.addEventListener('click', function (e) {
        e.preventDefault();
        flickity.stopPlayer();
        if (arrow.classList.contains('flickity__arrow--prev')) {
          flickity.previous();
        } else if (arrow.classList.contains('flickity__arrow--next')) {
          flickity.next();
        }
      });
    });
  }

  /*--------------------
  Dot Nav
  --------------------*/

  // Save the dot nav items (can be thumbnails, text, etc)

  var dotNavItems = container.querySelectorAll('.flickity-dot-nav__item');
  var dotNavs = container.querySelectorAll('.flickity-dot-nav');

  if (dotNavs.length > 0) {
    [].concat((0, _toConsumableArray3.default)(dotNavs)).forEach(function (nav) {
      var navItems = nav.querySelectorAll('.flickity-dot-nav__item');

      if (navItems.length > 0) {
        // Add the active class to the first dot.
        navItems[0].classList.add('active');

        // Event listener on dot click.

        [].concat((0, _toConsumableArray3.default)(navItems)).forEach(function (dot, index) {
          // Go to the slide
          dot.addEventListener('click', function () {
            flickity.select(index);

            // Pause the slider
            flickity.stopPlayer();
          });
        });
      }
    });
  }

  /*--------------------
  Count
  --------------------*/

  var flickityNavCount = container.querySelector('.flickity-nav-count');

  /*--------------------
  On Select
  --------------------*/

  flickity.on('select', function (index) {
    // Dot Nav
    if (dotNavs.length > 0) {
      [].concat((0, _toConsumableArray3.default)(dotNavs)).forEach(function (nav) {
        var navItems = nav.querySelectorAll('.flickity-dot-nav__item');

        if (navItems.length > 0) {
          // Remove active class from dots
          [].concat((0, _toConsumableArray3.default)(navItems)).forEach(function (dot) {
            dot.classList.remove('active');
          });
          // Add active class to selected dot
          var selectedDot = navItems[index];
          selectedDot.classList.add('active');
        }
      });
    }

    // Count
    if (flickityNavCount) {
      var currentSlide = flickity.selectedIndex + 1;
      var totalCount = flickity.slides.length;
      flickityNavCount.innerText = currentSlide + ' / ' + totalCount;
    }
  });

  return flickity;
}